module.exports = __webpack_public_path__ + "static/img/team3.6a97340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team3.png
// module id = 1na9
// module chunks = 36